<template>
  <div class="about">
    <h1>{{ $t("about.title") }}</h1>

    <p class="date">
      <span class="icon sun">{{ $t("about.marionDate1") }}</span>
      <span class="icon moon">{{ $t("about.marionDate2") }}</span>
    </p>

    <section class="marion">
      <div v-if="smallScreen" class="image-container"></div>
      <div class="content-container">
        <p>{{ $t("about.marion1") }}</p>
        <p>{{ $t("about.marion2") }}</p>
        <p>{{ $t("about.marion3") }}</p>
        <p>{{ $t("about.marion4") }}</p>
      </div>
      <div v-if="!smallScreen" class="image-container"></div>
    </section>

    <div class="banner-wrapper"></div>

    <section class="logo">
      <h2 v-if="smallScreen">{{ $t("about.logoTitle") }}</h2>
      <div class="image-container"></div>

      <div class="content-container">
        <h2 v-if="!smallScreen">{{ $t("about.logoTitle") }}</h2>
        <p>{{ $t("about.logoSubtitle") }}</p>
        <!-- <p>{{ $t('about.logo1') }}</p> -->
      </div>

      <p>{{ $t("about.logo1") }}</p>
    </section>
  </div>
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
export default {
  name: "About",
  components: {},
  props: [],

  /* ------------------------------ */
  /* DATA */
  data() {
    return {};
  },

  /* ------------------------------ */
  /* LIFECYCLE HOOKS */
  /* note: do not use arrow functions here */
  beforeCreate: function () {},
  created: function () {},
  beforeMount: function () {},
  mounted: function () {},
  beforeDestroy: function () {},
  destroyed: function () {},

  /* ------------------------------ */
  /* METHODS ETC */
  methods: {},
  computed: {},
  watch: {},
};
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss" scoped>
.about {
  @include max-medium {
    margin-bottom: $margin-bottom-mobile;
  }

  @include min-large {
    margin-bottom: $margin-bottom-desktop;
  }
}
/* general */

section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: $padding-mobile;
  padding-right: $padding-mobile;

  p {
    margin: $p-padding 0;
  }
  @include maxWidthCenter();
  @include min-large {
    @include flex(center, stretch);
  }
}

.content-container {
  @include min-large {
    display: inline-block;
    width: 60%;
  }
}

.image-container {
  @include max-medium {
    height: 200px;
    margin-bottom: 16px;
  }
  @include min-large {
    position: relative;
    display: inline-block;
    width: 40%;
    padding: 40px;
  }
}

/* section specific */

.date {
  position: relative;

  @include maxWidthCenter();
  margin-top: 10px;
  margin-bottom: 40px;
  color: $medium-grey;

  @include min-large {
    text-align: center;
  }

  .icon {
    position: relative;
    padding-left: 40px;

    &:before {
      position: absolute;
      width: 20px;
      height: 20px;
      top: 50%;
      transform: translateY(-50%);
      left: 14px;
    }

    &.sun {
      &:before {
        content: url(../assets/img/sun.svg);
        padding: 1px;
      }
    }
    &.moon {
      @include max-medium {
        float: right;
        margin-right: $padding-mobile;
      }
      @include min-large {
        margin-left: 40px;
      }
      &:before {
        content: url(../assets/img/star.svg);
        padding: 1px;
      }
    }
  }
}

.marion {
  margin-top: 0;

  .content-container {
    padding-right: 20px;
  }

  .image-container {
    position: relative;
    @include image-background(
      "photo_marion_bw_contrast.png",
      center,
      center,
      cover,
      "../"
    );
    @include image-background(
      "photo_marion_group_bw.png",
      top,
      right,
      cover,
      "../"
    );
    margin-bottom: 16px;
    // background-color: $green-3;

    @include max-medium {
      min-height: 400px;
      background-position-y: -50px;
    }

    &:after {
      // content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: $bright-green;
      opacity: 0.4;
    }
  }
}

.banner-wrapper {
  height: 480px;
  margin-top: 80px;
  margin-bottom: 80px;
  padding: 80px 10px;
  //   background-color: darken($light-grey, 10%);
  background-color: #d9d9d9;
  @include image-background(
    "photo_marion_group_bw.png",
    center,
    -100px,
    cover,
    "../"
  );
  @include image-background(
    "blauwe_vogelhuis_baarn_pauline.jpg",
    center,
    30%,
    cover,
    "../"
  ); // TEST!! Was -100px
  text-align: center;

  @include max-medium {
    height: 330px;
    background-position-y: center;
  }
}

.logo {
  flex-wrap: wrap;

  @include min-large {
    > p {
      margin-top: 40px;
    }
  }

  h2 {
    flex: 0 0 100%;
    margin-bottom: 40px;
  }

  .content-container {
    @include min-large {
      h2 {
        margin-top: 30px;
        margin-bottom: 20px !important;
        text-align: left;
      }
      p {
        margin-top: 12px;
        margin-bottom: 12px;
      }
      width: 50%;
      padding-left: 20px;
    }
  }

  .image-container {
    // background-color:#3C4649;
    @include image-background("logo.jpg", center, center, contain, "../");

    @include min-large {
      width: 50%;
    }
  }
}
</style>
